import React from 'react';
import './index.scss';
import { getPercentageInfo } from '@op/utils';
import { channelInfo } from '@op/components/ChannelLabel';

function ChartProgressItem({
  title,
  value,
  percentage,
}: {
  title: string;
  value: number;
  percentage: string;
}) {
  return (
    <div className="dbo-chart-progress-item">
      <div className="dbo-chart-progress-item-hd">
        <div className="dbo-chart-progress-item-title">{title}</div>
      </div>
      <div className="dbo-chart-progress-item-bd">
        <div
          className="dbo-chart-progress-item-bar"
          style={{ width: `${percentage}`, backgroundColor: '#5086F3' }}
        ></div>
        <div className="dbo-chart-progress-item-value">{`${value} (${percentage})`}</div>
      </div>
    </div>
  );
}

export default function ChartProgress({
  data,
  total = 0,
  translate,
}: {
  data: Array<{ name: string; value: number }>;
  total: number;
  translate: (value: string) => string;
}) {
  return (
    <div className="dbo-chart-progress-list">
      {data?.map((item: any) => {
        if (item.name === 'others') return null;
        const channel = channelInfo(item.name);
        return (
          <ChartProgressItem
            key={item.name}
            title={translate(channel.name)}
            value={item.value}
            percentage={getPercentageInfo(item.value, total, 2)}
          />
        );
      })}
    </div>
  );
}
